module.exports = __webpack_public_path__ + "img/ync.66683c1c.png";